import { useState } from "react";
import axios from "axios";
import {
  Flex,
  Box,
  FormControl,
  FormLabel,
  Input,
  Checkbox,
  Stack,
  Link,
  Button,
  Heading,
  Text,
  useColorModeValue,
  Center,
} from "@chakra-ui/react";
import { useToast } from "@chakra-ui/react";
import { FcGoogle } from "react-icons/fc";
import { Link as RouterLink } from "react-router-dom";
import Signup from "../Signup";
import { FcUnlock } from "react-icons/fc";
import { useAuth0 } from "@auth0/auth0-react";
import { useNavigate } from "react-router-dom";

const Login = ({ onClose }) => {
  const { loginWithRedirect, getAccessTokenSilently } = useAuth0();
  const [ShowSignup, setShowSignup] = useState(false);
  const [data, setData] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [msg, setMsg] = useState("");
  const [accessToken, setAccessToken] = useState("");


  // to navigate to homepage if login succes
  const navigate = useNavigate();


  const toast = useToast();

  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    axios.defaults.baseURL = "https://glb-api.onrender.com";
    try {
      const url = "/api/auth";
      const response = await axios.post(url, data, {
        withCredentials: true,
      });
      setMsg(response.data.message);
      localStorage.setItem("token", response.data);
      onClose();
      toast({
        title: "Login Successful",
        description: "You have successfully logged in.",
        status: "success",
        duration: 5000,
        isClosable: true,
      });
      // navigate("/");
    } catch (err) {
      if (
        err.response &&
        err.response.status >= 400 &&
        err.response.status <= 500
      ) {
        setError(err.response.data.message);
      }
    }
  };

  const handleSignupClick = () => {
    setShowSignup(true);
  };

  const handleGetAccessToken = async () => {
    try {
      const token = await getAccessTokenSilently();
      setAccessToken(token);
    } catch (err) {
      console.error("Failed to retrieve access token:", err);
    }
  };

  return (
    <Flex align={"center"} justify={"center"}>
      <Stack spacing={8} mx={"auto"} maxW={"lg"} py={8} px={6}>
        <Stack align={"center"}>
          <Heading fontSize={"4xl"}>Sign in to your account</Heading>
          <Text fontSize={"lg"} color={"gray.600"}>
            to enjoy all of our cool <Link color={"blue.400"}>features</Link>{" "}
            ✌️
          </Text>
        </Stack>
        <Box
          rounded={"lg"}
          bg={useColorModeValue("white", "gray.700")}
          boxShadow={"lg"}
          p={4}
        >
          <Stack spacing={4}>
            {error && (
              <Center>
                <FcUnlock size={15} />
                <Box ml={2}>
                  {error && <Text color="red.500">{error}</Text>}
                  {msg && <Text color="green.500">{msg}</Text>}
                </Box>
              </Center>
            )}

            <form onSubmit={handleSubmit}>
              <FormControl id="email" marginBottom={5}>
                <FormLabel>Email address</FormLabel>
                <Input
                  type="email"
                  name="email"
                  value={data.email}
                  onChange={handleChange}
                />
              </FormControl>
              <FormControl id="password" marginBottom={5}>
                <FormLabel>Password</FormLabel>
                <Input
                  type="password"
                  name="password"
                  value={data.password}
                  onChange={handleChange}
                />
              </FormControl>
              <Stack
                spacing={10}
                direction={{ base: "column", sm: "row" }}
                align={"start"}
                justify={"space-between"}
                marginBottom={5}
              >
                <Checkbox>Remember me</Checkbox>
                <Link href="forgetpassword" color={"blue.400"}>Forgot password?</Link>
              </Stack>
              <Button
                minWidth={"100%"}
                bg={"blue.400"}
                color={"white"}
                _hover={{
                  bg: "blue.500",
                }}
                type="submit"
              >
                Sign in
              </Button>
              <Center marginTop={5}>
                <Button
                  minWidth={"100%"}
                  variant={"outline"}
                  leftIcon={<FcGoogle />}
                  onClick={() => loginWithRedirect()}
                >
                  Log In
                </Button>
              </Center>

              <Center marginTop={5}>
                <Text fontSize="sm">
                  New Here?{" "}
                  <Link
                    as={RouterLink}
                    to="/signup"
                    color="blue"
                    onClick={handleSignupClick}
                  >
                    Register Now
                  </Link>
                </Text>
              </Center>
            </form>

            {accessToken && (
              <Center marginTop={5}>
                <Text>
                  Access Token: <code>{accessToken}</code>
                </Text>
              </Center>
            )}
            <Button
              minWidth={"100%"}
              variant={"outline"}
              onClick={handleGetAccessToken}
            >
              Get Access Token
            </Button>
          </Stack>
        </Box>
      </Stack>
    </Flex>
  );
};

export default Login;
